export const TESTIMONIALS = [
  {
    image: "/images/avatars/kevin-mascarenhas.jpg",
    name: "Kevin Mascarenhas",
    description: "Gym goer",
    review: `PB meals have been really fantastic especially their Post Work Out meals. If you are a gym goer and looking for a clean source of Low Carb Hi Protein meal, simply choose Protein Box`,
  },
  {
    image: "/images/avatars/nargis-chimthanawala.jpg",
    name: "Nargis Chimthanawala",
    description: "Customer",
    review: `The fish was fresh n delicious n perfectly cooked.. loved it!`,
  },
  {
    image: "/images/avatars/jyotsna.jpg",
    name: "Jyotsna",
    description: "Working Professional",
    review: `Being a working professional, I simply don't get time to cook my meals. Protein Box has such a wide range of healthy salads, it is simply amazing! try it to believe`,
  },
  {
    image: "/images/avatars/maria-blanche-mascarenhas.jpg",
    name: "Maria Blanche Mascarenhas",
    description: "Diet freak",
    review: `It has been 1.5 months of clean eating with Protein Box & I already lost more than 2 kgs.\nI love this concept where in they provide  custom curated healthy meals and also have a dedicated dietician on-board.\nThe food is super light & freshly prepared. Their in house dietician does diet counselling post nutritional health assessment,  and suggests necessary lifestyle modification. This journey with Protein Box has been amazing. Kudos Team Protein Box!!`,
  },
  {
    image: "/images/avatars/meenal-bhoyar.jpg",
    name: "Meenal Bhoyar",
    description: "Dietitian",
    review: `Being a dietitian i understand the availability of correct food on a correct time. protein box made diet compliance easier for me. protein salads with exotic veggie is just yummy , fulfilling ,powerpacKed with all nutrients. All vegetables used were fresh. texture and presentation was perfect. Ideal for those who are on weight loss regime`,
  },
  {
    image: "/images/avatars/akshay-ganer.jpg",
    name: "Akshay Ganer",
    description: "Body builder",
    review: `Being a Pro Athlete & a Professional Body Builder, I need to be absolutely to the point with regards to my macros. One brand that i can trust fully is without a doubt - Protein Box . \n\nNo wonder when it comes to clean food and knowing the macros better Protein Box leads the show`,
  },
];